import React from "react";
import BPGetMyRate from "../broker/BPGetMyRate";
import BCError from "../BCError";

const GetMyRate = ({ ...props }) => {
  return (
    <React.Fragment>
      {props.user.portal === "Broker" ? <BPGetMyRate 
        isGreaterThanMobile={props.isGreaterThanMobile}
        isGreaterThanTablet={props.isGreaterThanTablet}
        isSidebar={props.isSidebar}
        isMessage={props.isMessage}
        setIsMessage={props.setIsMessage}
        errorResponse={props.errorResponse}
        setErrorResponse={props.setErrorResponse}
        proxyUser={props.proxyUser}
        permissions={props.permissions}
        gmrId={props.gmrId}
        brokerColor={props.brokerColor}
        setGmrEditData={props.setGmrEditData}
        copiedGmrId={props.copiedGmrId}
        isPricingStartScenarios={props.isPricingStartScenarios}
        setIsPricingStartScenarios={props.setIsPricingStartScenarios}
        user={props.user}
      /> : <BCError 
        isGreaterThanTablet={props.isGreaterThanTablet}
        isSidebar={props.isSidebar}
      />}
    </React.Fragment>
  );
};

export default GetMyRate;